// extracted by mini-css-extract-plugin
module.exports = {"title":"UserInList_title__fPZAK","image":"UserInList_image__Rqmn8"};